import { useCentralApi, useCurrentUser } from "hooks/shared";
import { IWorkItemTemplate } from "models/work-items";
import { useEffect, useState } from "react";


type UseWorkItemTemplateResult = [
    IWorkItemTemplate | null,
    boolean
];

type UseWorkItemTemplateProps = {
    workItemId?: number;
    templateId?: number;
}

type UseWorkItemTemplateSignature = (props: UseWorkItemTemplateProps) => UseWorkItemTemplateResult;

const useWorkItemTemplate: UseWorkItemTemplateSignature = (props) => {
    const { workItemId, templateId } = props;

    const [ result, setResult ] = useState<IWorkItemTemplate | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);

    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        if (!user || !user.access_token)
            return;
        if (!workItemId && !templateId)
            return;
        const controller = new AbortController();

        (async () => {
            setLoading(true);
            try {
                const url = workItemId
                    ? `/api/v3/workitems/${workItemId}/template`
                    : `/api/v3/templates/work-items/${templateId}`;
                const resp = await fetcher(url, {
                    signal: controller.signal
                }, async (resp) => {
                    return resp.status === 404;                        
                });

                if (!resp.ok) {
                    if (resp.status === 404) {
                        return;
                    } else {
                        return;
                    }
                }

                const data = await resp.json() as IWorkItemTemplate;
                setResult(data);
            } finally {
                if (!controller.signal.aborted)
                    setLoading(false);
            }
        })();    
    }, [ workItemId, templateId, user ]);
    
    return [
        result,
        loading
    ];
};

export default useWorkItemTemplate;